import { MutationTree } from 'vuex'
import { ChatState } from '@/store/chat/types'
import { ChatMessages } from './types'

export enum ChatMutations {
  SET_MESSAGES = 'SET_MESSAGES',
  ADD_MESSAGES = 'ADD_MESSAGES',
  SET_PAGINATION = 'SET_PAGINATION'
}

export const mutations: MutationTree<ChatState> = {
  [ChatMutations.SET_MESSAGES](
    state: ChatState,
    payload: { messages: ChatMessages[]; totalPages: number }
  ) {
    state.messages = payload.messages
    state.totalPages = payload.totalPages
  },

  [ChatMutations.ADD_MESSAGES](
    state: ChatState,
    payload: { messages: ChatMessages[]; totalPages: number }
  ) {
    state.messages = [...payload.messages, ...state.messages]
    state.totalPages = payload.totalPages
  }
}
